import api from '../api';
import { handleError } from './helper';
export const getTableData = () => {};
export const updateTableData = () => {};

export const updateSelectedSize = (size) => (dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_SIZE',
    payload: size,
  });

export const updateSelectedUnitType = (type) => (dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_UNIT',
    payload: type,
  });

export const getPriceCards = (data) => (dispatch) => {
  dispatch({
    type: 'IS_LOADING',
  });
  // -- enable this code to use local storage data when required

  // if (process.env.NODE_ENV === 'development' && localStorage.getItem('data')) {
  //   dispatch({
  //     type: 'FETCH_DATA_SUCCESS',
  //     payload: JSON.parse(localStorage.getItem('data')),
  //   });
  //   dispatch({
  //     type: 'IS_NOT_LOADING',
  //   });
  // } else {
  api
    .getPriceCards(data)
    .then((res) => {
      localStorage.setItem(
        'data',
        JSON.stringify({
          priceCards: res[0].data.data || [],
          kpi: res[1].data,
        })
      );
      dispatch({
        type: 'FETCH_DATA_SUCCESS',
        payload: { priceCards: res[0].data.data || [], kpi: res[1].data },
      });
    })
    .catch((err) => {
      handleError(dispatch, err);
    })
    .finally(() => {
      dispatch({
        type: 'IS_NOT_LOADING',
      });
    });
  // }
};

export const UpdateSelectedTab = (tab) => (dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_TAB',
    payload: tab,
  });

export const updateStatusAll = (payload) => (dispatch) => {
  dispatch({
    type: 'IS_LOADING',
  });
  api
    .updateStatusAll(payload)
    .then((res) => {
      dispatch({
        type: 'UPDATE_STATUS_ALL',
        payload: payload,
      });
      if (payload.status === 'approved') {
        let unit = '';
        if (payload.unitType === 'Any') unit = 'All';
        else unit = payload.unitType;
        dispatch({
          type: 'SHOW_NOTIFICATION',
          payload: { message: `${unit} units Approved`, type: 'success' },
        });
      }
    })
    .catch((err) => {
      handleError(dispatch, err);
    });
};

export const updateStatus = (payload) => (dispatch) => {
  let input = {
    store: payload.item.store,
    unitType: payload.item.unitType,
    unitWidth: payload.item.unitWidth,
    status: payload.status,
  };
  api
    .updateStatus(input)
    .then((res) => {
      dispatch({
        type: 'UPDATE_STATUS',
        payload: payload,
      });
    })
    .catch((err) => {
      handleError(dispatch, err);
    });
};
